import { render } from "./SystemDesigner.vue?vue&type=template&id=022ce92a&scoped=true"
import script from "./SystemDesigner.vue?vue&type=script&lang=js"
export * from "./SystemDesigner.vue?vue&type=script&lang=js"

import "./SystemDesigner.vue?vue&type=style&index=0&id=022ce92a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-022ce92a"]])

export default __exports__